module.exports = __webpack_public_path__ + "img/chengguo.9b7705ee.png";